import { getAuthHeaders, tempMeeApi } from '~/services/api';
import { IGetJobPostDetailApiResponse } from '../types';

export const getJobPostDetail = async (id: string): Promise<IGetJobPostDetailApiResponse> => {
  const headers = await getAuthHeaders();

  const response = await tempMeeApi.get<IGetJobPostDetailApiResponse>(
    `/posting-service/postings/${id}`,
    {
      headers,
    },
  );

  return response.data;
};
